<script lang="ts">
	import { setContext } from 'svelte'
	import { writable } from 'svelte/store'
	import LotFileUpload from './LotFileUpload.svelte'
	import LotComments from './LotComments.svelte'
	import LotAnalyticalList from './LotAnalyticalList.svelte'
	import { t } from '../../../../i18n/i18n'
	import LotStateChanger from './LotStateChanger.svelte'
	import {
		AnalyticalType,
		LotState,
		LotType,
		OPTIMIZED_STATES,
		UserPermission
	} from '../../../types/enums'
	import QuoteAttachments from './QuoteAttachments.svelte'
	import FakAccordionItem from '../FakAccordionItem.svelte'
	import FakAccordionItemHeader from '../FakAccordionItemHeader.svelte'
	import LotForm from './LotForm.svelte'
	import NullableDataWrapper from '../../../utils/NullableDataWrapper.svelte'
	import { currentLot } from '../utils/fakStores'
	import LotMaterialForm from './LotMaterialForm.svelte'
	import SaveNewLotItem from './SaveNewLotItem.svelte'
	import Badge from '../../../atoms/Badge.svelte'
	import { hasPermissions } from '../../../menubar/Permission.svelte'
	import { jwt } from '../../../utils/jwt'

	setContext('selectedItemId', writable(null))

	let analyticString
	let hasAnalyticals
	let hasAttachments
	let isNotNewLot = $currentLot.id !== 'new'
	let analyticalType =
		$currentLot?.type === LotType.BACKFILL || $currentLot?.type === LotType.MATERIAL_NEED
			? AnalyticalType.ANALYTIC
			: AnalyticalType.ANALYSIS

	$: analyticalType =
		$currentLot?.type === LotType.BACKFILL || $currentLot?.type === LotType.MATERIAL_NEED
			? AnalyticalType.ANALYTIC
			: AnalyticalType.ANALYSIS
	$: if ($currentLot) {
		if ($currentLot.type === LotType.DISPOSAL) {
			analyticString = $t('UI.map.analytic.disposal')
		} else if ($currentLot.type === LotType.MATERIAL_SALE) {
			analyticString = $t('UI.map.analytic.materialSale')
		} else {
			analyticString = $t('UI.map.analytic.materialNeed')
		}

		// This is necessary because of the delay caused by various animation durations and delays
		setTimeout(() => {
			isNotNewLot = $currentLot?.id !== 'new'
		}, 601)
	}
</script>

<ul id="lot-details-accordion" class="position-details-accordion">
	<NullableDataWrapper bind:data={$currentLot} delay={500}>
		<li style="width: 100%; background: #FFF; border-radius: 0.25rem; margin-bottom: 0.625rem;">
			<LotForm />
		</li>

		<FakAccordionItem id={0} closeOnHeaderClick openByDefault>
			<div slot="header">
				<FakAccordionItemHeader label={$t('UI.map.card.lot.material')} id={0} />
			</div>
			<div slot="body" style="width: 100%; height: 100%;">
				<LotMaterialForm />
			</div>
		</FakAccordionItem>

		<!-- Positionsbemerkungen -->
		<FakAccordionItem id={1} closeOnHeaderClick>
			<div slot="header">
				<FakAccordionItemHeader label={$t('UI.map.card.lot.remarks')} id={1} />
			</div>
			<div slot="body" style="width: 100%; height: 100%;">
				<LotComments />
			</div>
		</FakAccordionItem>

		{#if isNotNewLot}
			<!-- Positionsdateien -->
			<FakAccordionItem id={2} closeOnHeaderClick>
				<div slot="header">
					<FakAccordionItemHeader
						label={hasAttachments
							? $t('UI.map.card.lot.attachments')
							: $t('UI.map.card.lot.addAttachments')}
						id={2}
					/>
				</div>
				<div slot="body" style="width: 100%; height: 100%;">
					<LotFileUpload bind:hasAttachments />
				</div>
			</FakAccordionItem>

			{#if $currentLot.state === LotState.BIDDING || OPTIMIZED_STATES.includes($currentLot.state)}
				<!-- Anfragedateien -->
				<FakAccordionItem id={3} closeOnHeaderClick>
					<div slot="header">
						<FakAccordionItemHeader label={$t('UI.map.card.quote.attachments')} id={3} />
					</div>
					<div slot="body" style="width: 100%; height: 100%;">
						<QuoteAttachments />
					</div>
				</FakAccordionItem>
			{/if}

			<!-- Analytik -->
			<FakAccordionItem id={4} closeOnHeaderClick>
				<div slot="header">
					<!-- TODO: Show badge only if notification state matches (has not been used) MF-593 -->
					<FakAccordionItemHeader
						label={analyticString + (!hasAnalyticals ? ' hinzufügen' : '')}
						id={4}
						showBadge={analyticalType === AnalyticalType.ANALYSIS &&
							hasPermissions(UserPermission.IMPORT_ANALYTICS, $jwt.perms)}
					>
						<Badge
							slot="badge"
							text={$t('UI.badge.newFunctionality')}
							backgroundColor="#D6FAE2"
							color="#58C079"
							uppercase
							dataset={[
								['badgeType', 'news'],
								['dataNewsId', 'ai-analysis']
							]}
							classes={['news-badge']}
						/>
						<!-- TODO: Update colors when map is merged (includes new color system) -->
					</FakAccordionItemHeader>
				</div>
				<div
					slot="body"
					style="width: 100%; display: flex; justify-content: center; align-items: center;"
				>
					<LotAnalyticalList bind:hasAnalyticals />
				</div>
			</FakAccordionItem>

			<!-- Status -->
			<FakAccordionItem id={5} closeOnHeaderClick openByDefault>
				<div slot="header">
					<FakAccordionItemHeader label={$t('UI.map.card.lot.status')} id={5} />
				</div>
				<div slot="body" style="width: 100%; height: 100%;">
					<LotStateChanger />
				</div>
			</FakAccordionItem>

			<!--{#if $currentLot.state === LotState.BIDDING}
                &lt;!&ndash; Optimierer Management &ndash;&gt;
                <FakAccordionItem id={5} closeOnHeaderClick={true} openByDefault={true}>
                    <div slot="header" style="height: 3.875rem; width: 100%">
                        <FakAccordionItemHeader label={$t('UI.map.card.lot.optimizerManagement')} id={5}/>
                    </div>
                    <div slot="body" style="width: 100%; height: 100%;">
                        <LotOptimizerManagement/>
                    </div>
                </FakAccordionItem>
            {/if}-->
		{/if}
		{#if $currentLot && $currentLot.id === 'new'}
			<SaveNewLotItem />
		{/if}
	</NullableDataWrapper>
</ul>

<style lang="scss">
	.position-details-accordion {
		width: 450px;
		padding-left: 0;
		list-style: none;
	}
</style>
